// metadata/tree.ts
var Tree = class {
  constructor(root) {
    this.root = root;
  }
  find(compareFn, node = this.root) {
    if (compareFn(node))
      return node;
    for (const childNode of node.children) {
      const foundNode = this.find(compareFn, childNode);
      if (foundNode)
        return foundNode;
    }
  }
  forEach(fn, node = this.root, depth = 0) {
    fn(node, depth);
    node.children.forEach((child) => this.forEach(fn, child, depth + 1));
  }
  forEachRev(fn, node = this.root, depth = 0) {
    node.children.forEach((child) => this.forEachRev(fn, child, depth + 1));
    fn(node, depth);
  }
  async forEachAsync(fn, node = this.root, depth = 0) {
    await fn(node, depth);
    for (const child of node.children)
      await this.forEachAsync(fn, child, depth + 1);
  }
  async forEachRevAsync(fn, node = this.root, depth = 0) {
    for (const child of node.children)
      await this.forEachRevAsync(fn, child, depth + 1);
    await fn(node, depth);
  }
  reduce(fn, startVal, node = this.root, depth = 0) {
    let nextVal = fn(startVal, node, depth);
    node.children.forEach((child) => nextVal = this.reduce(fn, nextVal, child, depth + 1));
    return nextVal;
  }
  map(fn, node = this.root, depth = 0) {
    let results = [fn(node, depth)];
    for (const child of node.children)
      results = results.concat(fn(child, depth + 1));
    return results;
  }
  get size() {
    let size = 0;
    this.forEach((n) => size++);
    return size;
  }
};
export {
  Tree
};
